<h1>{{ "sharedPool" | i18n }}</h1>
<div
  class="shared-pool-list"
  *ngIf="user$ | async">
  <div
    *ngIf="subscriptionLoading$ | async"
    class="loading-message">
    {{ "loading" | i18n }}
  </div>
  <div
    *ngIf="
      !(subscriptionLoading$ | async) &&
      (sharedPoolCustomers$ | async)?.length === 0
    "
    class="no-customers-message">
    {{ "noSharedPoolCustomers" | i18n }}
  </div>
  <div
    class="card-box shared-pool-item"
    *ngFor="let sharedCustomer of sharedPoolCustomers$ | async">
    <div class="row">
      <div class="col-10 col-md-8">
        <div class="customer-title">{{ sharedCustomer.name }}</div>
        <mat-checkbox
          [checked]="isCustomerSelected(sharedCustomer._id)"
          (change)="toggleCustomerSelection(sharedCustomer._id)"
          [attr.data-cy]="'shared-pool-customer-' + sharedCustomer._id">
          {{ "sharedPoolCanDirectBook" | i18n }}
        </mat-checkbox>
        <br />
        <mat-checkbox
          [checked]="isAllowUndecidedSelected(sharedCustomer._id)"
          (change)="toggleAllowUndecidedSelection(sharedCustomer._id)"
          [attr.data-cy]="'shared-pool-allow-undecided-' + sharedCustomer._id">
          {{ "sharedPoolAllowUndecided" | i18n }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
